export default "__VITE_ASSET__CMaiXz4u__$_?no-inline__"